import { createSlice } from '@reduxjs/toolkit';

const initialState: UpdateCartItemsState = {
    needUpdate: false,
};

export const updateCartItemsSlice = createSlice({
    name: 'update-cart-items',
    initialState,
    reducers: {
        setItemsUpdate: (state) => {
            state.needUpdate = !state.needUpdate;
        },
    },
});

export interface UpdateCartItemsState {
    needUpdate: boolean;
}

export const updateCartItemsAction = updateCartItemsSlice.actions;

export default updateCartItemsSlice.reducer;
